import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../store/AppContext';
import { useAuthStore } from '../../store/AuthContext';
import { BackMappings } from '../../utils/BackMappings';
import { HostProvider } from '../../utils/HostProvider';
import { MisDatosConstants } from '../../utils/MisDatosConstants';
import { SessionChecker } from '../../utils/SessionChecker';
import { MisDatosHelper } from './MisDatosHelper';
import { StorageHelper } from '../../utils/StorageHelper';

interface Props {
  setVisible: (visible: boolean) => void;
  isDigital: boolean;
  isEroski: boolean;
  setIsDigital: (isDigital: boolean) => void;
  setIsEroski: (isEroski: boolean) => void;
  tipoSocio?: number;
  showModal: boolean;
  setShowModal: (show: boolean) => void;
}

const SignOut: FC<Props> = (props) => {
  const {
    setVisible,
    isEroski,
    isDigital,
    setIsEroski,
    setIsDigital,
    tipoSocio,
    // Para el 8.4.7 Nueva opcion de baja solo para socios consumidores
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    showModal,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setShowModal,
  } = props;
  const { t } = useTranslation();
  const [errorRadio, setErrorRadio] = useState<boolean>(false);
  const dataUser = useAuthStore();
  const dataApp = useAppStore();
  const misDatosHelper = new MisDatosHelper();

  const comenzarBaja = async () => {
    if (isDigital || isEroski) {
      const response = await SessionChecker.checkSession(
        BackMappings.MISDATOS,
        dataApp.lang,
        dataUser.user.isApp === 'true',
        dataUser.user.isRecuerdame,
      );
      if (response) {
        setErrorRadio(false);
        setVisible(true);
        document.body.classList.add('fix');
      }
    } else {
      setErrorRadio(true);
    }
  };
  const onChangeInputSocio = () => {
    setIsEroski(!isEroski);
    if (!isEroski || !HostProvider.isCaprabo()) {
      setErrorRadio(false);
    }
  };

  useEffect(() => {
    const padre = document.getElementById(
      `datos__bloque-baja`,
    ) as HTMLDivElement;
    const isScrollBaja = StorageHelper.getScrollBaja() as string;
    if (padre !== null && isScrollBaja !== null && isScrollBaja !== undefined) {
      misDatosHelper.scrollToResponsive(padre);
      StorageHelper.removeScrollBaja();
    }
  });

  return (
    <>
      <div className="divider" />
      <div className="bloque-datos__datos" id="datos__bloque-baja">
        <h2 id="baja" className="bloque-datos__title u-text-brand">
          <span className="divider__square brand-color" />
          <span className="u-margin-right"> {t('datos.baja.title')}</span>
        </h2>

        <p className="u-margin-bottom"> {t('datos.baja.where-unsubscribe')}</p>

        <form className="check-options">
          <fieldset>
            <label className="checkgroup" htmlFor="cuenta-digital">
              {t('datos.baja.digital-account')}
              <input
                type="checkbox"
                id="cuenta-digital"
                className="form-control"
                checked={isDigital}
                onChange={() => {
                  setIsDigital(!isDigital);
                  if (!isDigital) {
                    setErrorRadio(false);
                  }
                }}
              />
              <span className="checkmark" />
            </label>
            {dataUser.user.isFB !== true &&
            (tipoSocio === MisDatosConstants.TIPO_SOCIO_EROSKI_CLUB ||
              tipoSocio === MisDatosConstants.TIPO_SOCIO_AMBOS ||
              tipoSocio === MisDatosConstants.TIPO_SOCIO_AMBOS_ANTIGUO) ? (
              <label className="checkgroup" htmlFor="socio">
                {HostProvider.isEroski() ? (
                  <span>{t('datos.baja.partnerShip')} </span>
                ) : (
                  ''
                )}
                {HostProvider.isCaprabo() ? (
                  <span>{t('datos.baja.partnerShip-caprabo')} </span>
                ) : (
                  ''
                )}
                {tipoSocio === MisDatosConstants.TIPO_SOCIO_AMBOS ? (
                  <span>y {t('datos.baja.consumer')}</span>
                ) : (
                  ''
                )}
                <input
                  type="checkbox"
                  id="socio"
                  checked={isEroski}
                  className="form-control"
                  onChange={() => onChangeInputSocio()}
                />
                <span className="checkmark" />
              </label>
            ) : (
              ''
            )}
          </fieldset>
          {errorRadio && (
            // eslint-disable-next-line jsx-a11y/label-has-associated-control
            <label id="bajaOption-error" className="error" htmlFor="bajaOption">
              {t('validaciones.empty-radio')}
            </label>
          )}
          <div className="bloque-datos__datos">
            <p className="bloque-datos__link">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
              <a
                className="link u-margin-bottom"
                onClick={() => {
                  comenzarBaja();
                }}
              >
                {t('datos.baja.continue-unsubscribe-process')}
              </a>
            </p>

            {misDatosHelper.testSocioConsumidor(
              tipoSocio,
              dataUser.user.isFB,
            ) && (
              <p className="bloque-datos__link">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                <a
                  className="link"
                  onClick={() => {
                    setShowModal(!showModal);
                  }}
                >
                  {t('datos.baja.unsuscribe-as-consumer-partner')}
                </a>
              </p>
            )}
          </div>
        </form>
      </div>
    </>
  );
};

export default SignOut;
